export const DEFAULT_PROFIT_THRESHOLD = 0.2;
